/* eslint-disable prefer-arrow-callback */
/* eslint-disable no-unused-vars */
import EventEmmiter, { log, event } from './EventEmmiter';
import nativeInterface from './native';
import { bluetoothConnectStore } from '../mobx/stores/bluetooth';
import { terminalInstance } from '../pages/view/Terminal';
import { stepStore, MODE } from '../mobx/stores/step';
import {
  formatCommandNoEscape,
  autoCompleteCommand,
  loopExecuteFn,
  createError,
  stringToHex,
  stringToBinary,
  splitStringNumber,
  hexToDecimal,
  hexToFloat,
  formatGeoTime
} from '../js/utils';
import { COMMUNITION_ERRORS, NATIVE_ERRORS } from './ErrorHandler';
import { taskStore } from '../mobx/stores/task';
import { globalStore } from '../mobx/stores/global';
import { geoStore } from '../mobx/stores/geo';
import { logStore } from '../mobx/stores/log';
import { CPU2_COMMAND as CPU2_COMMAND_LIST } from '../service/command';
import { socket } from '../service/websocket';
import CmdLogManager from '../service/cmd-log-manager';

export const cmdLogManager = new CmdLogManager();

cmdLogManager.use(function (logContent, next) {
  console.log('日志：', logContent);
  next();
});

cmdLogManager.use(function (data, next) {
  // 添加地磁检测数据处理
  if (data.includes('parking status changed:')) {
    // 车位状态
    geoStore.setState(data);
  } else if (data.includes('g_v2')) {
    // geoStore.setGv2(data);
  } else if (data.includes('k_max')) {
    // 地磁检测数据
    geoStore.setRadarDetect(data);
  } else if (data.includes('[alg3 output]')) {
    // 算法输出参数值
    geoStore.setDetectValue(data);
    logStore.setXYZ(data);
  }
  next();
});

// 添加地磁工作状态
cmdLogManager.use(function (data, next) {
  if (data.includes('task_working_comm_enter')) {
    // 通信
    globalStore.geoWorkState = '通信';
  } else if (data.includes('task_working_probe_enter')) {
    // 检测
    globalStore.geoWorkState = '检测';
  } else if (data.includes('task_working_snooze_enter')) {
    // 休眠
    globalStore.geoWorkState = '休眠';
  }
  next();
});

cmdLogManager.use(function (data, next) {
  // console.log('CPU1重启成功后的日志：', data);
  if (data.includes('net_ok') || data.indexOf('frank.mode=0') !== -1) {
    event.emmitCallback('wait_reboot_cpu1_success', '0');
  }
  next();
});

const {
  connectBluetooth,
  sendCommandByBt,
  sendTestCommandByBt,
  closeBluetoothConnect
} = nativeInterface;

// 蓝牙通信接口回调
export const CALLBACKS = {
  SEND_COMMAND: 'sendCommand',
  SEND_TEST_COMMAND: 'sendTestCommand'
};

// 原生接口回调
export const NATIVE_CALLBACKS = {
  CONNECT_BLUETOOTH: 'connectBluetooth',
  CLOSE_CONNECT: 'closeConnect'
};

// 事件监听前缀
const STEPS = {
  CONNECT_BLUETOOTH: 'connectBluetooth',
  SEND_COMMAND: 'sendCommand',
  SEND_TEST_COMMAND: 'sendTestCommand',
  CLOSE_CONNECT: 'closeConnect'
};

const HEX_DATA_PREFIX = '[09hexdata]';

// 数据校验
function verifyData(data, expect) {
  if (expect.indexOf('regexp:') === 0) {
    const reg = new RegExp(expect.replace('regexp:', ''));
    return !!data.match(reg);
  }

  return data.indexOf(expect) >= 0;
}

// 蓝牙通信的结束标记
export const END_SIGN = '\r\n>>(\r\n)+';

/**
 * @description 数据接收是否结束
 * @param {string} data
 * @returns {boolean}
 * @memberof RFBluetooth
 */
function isEnd(data) {
  const endSign = new RegExp(`${END_SIGN}$`);
  return endSign.test(data);
}


/**
 * @description 删除结束标记
 * @export
 * @param {string} data
 * @returns
 */
export function replaceEnd(data) {
  const endSign = new RegExp(`${END_SIGN}`, 'g');
  return data.replace(endSign, '');
}

export class RFBluetooth extends EventEmmiter {
  constructor() {
    super();
    this.timer = null;
    // 当前执行步骤
    this.currentStep = '';
    // 当前执行步骤的返回数据，命令返回结果会分包传输
    this.currentStepData = '';
  }

  // 连接地磁蓝牙
  connectBluetooth(test) {
    return super.execute({
      max: 3,
      interval: 65 * 1000,
      step: STEPS.CONNECT_BLUETOOTH,
      resolveCode: false,
      executeFn: () => {
        connectBluetooth();
      }
    }).then(({ count, data }) => {
      globalStore.btOnConnect = true;
      bluetoothConnectStore.status = 'success';
      bluetoothConnectStore.btData = {
        id: data[0],
        name: data[1]
      };

      log.postSuccess({
        operate: '连接地磁蓝牙',
        receive: JSON.stringify(data),
        receiveOrigin: JSON.stringify(data),
        count
      });

      return Promise.resolve();
    }).catch((error) => {
      globalStore.btOnConnect = false;
      bluetoothConnectStore.status = 'error';
      log.postError({
        operate: '连接地磁蓝牙',
        error
      });
      return Promise.reject(error);
    });
  }

  // 关闭蓝牙连接
  closeConnect() {
    return super.execute({
      max: 3,
      interval: 10 * 1000,
      step: STEPS.CLOSE_CONNECT,
      resolveCode: false,
      executeFn: () => {
        closeBluetoothConnect();
      }
    }).then(({ count }) => {
      log.postSuccess({
        operate: '关闭蓝牙连接',
        count
      });
      return Promise.resolve();
    }).catch((error) => {
      log.postError({
        operate: '关闭蓝牙连接',
        error
      });
      return Promise.reject(error);
    });
  }

  /**
   * @description 发送蓝牙命令
   * @param {string} command 命令
   * @param {object}
   * @property {number} max 最大重试次数
   * @property {string} command 命令
   * @property {string} expect 校验内容
   * @property {number} overtime 超时时间
   * @property {boolean} logBack 是否根据日志判断结束标记
   * @property {boolean} batch 是否是批命令
   * @returns
   * @memberof RFBluetooth
   */
  sendCommand(command, {
    name = '',
    max = 3,
    expect = '',
    error = 'err',
    overtime = 15,
    logBack = false, // 是否根据日志判断结束标记
    batch = false // 是否是批命令
  }) {
    const isExpert = stepStore.mode === MODE.EXPERT || globalStore.operateMode === MODE.EXPERT;
    // 如果是命令行则不进行重试
    // eslint-disable-next-line no-param-reassign
    max = isExpert ? 1 : max;
    const session = taskStore.getSessionId();
    const target = this.getCommandType(command);
    this.completeData = [];

    this.batch = batch;

    console.log(`sendCommand: ${name || command}   ${session}`);

    return this.execute({
      name,
      max,
      logBack,
      session,
      target,
      expect,
      interval: overtime * 1000,
      overtime: overtime * max,
      step: STEPS.SEND_COMMAND,
      resolveCode: true,
      executeFn: () => {
        const cmd = /.*\r\n$/.test(command) ? command : formatCommandNoEscape(command);
        sendCommandByBt(session, target, cmd);
      },
      loadFn: (data) => {
        if (isExpert) {
          const msg = data.replace('\r\n', '<br/>');
          terminalInstance.output(msg);
          socket.emitCommandResponse({
            state: 'load',
            data: msg
          });
        }
      }
    }).then(({ count, data }) => {
      log.postSuccess({
        operate: name || '发送蓝牙命令',
        send: command,
        receive: data,
        receiveOrigin: data,
        count
      });

      return Promise.resolve(data);
    }).catch((errorBack) => {
      log.postError({
        operate: name || '发送蓝牙命令',
        send: command,
        error: errorBack
      });
      return Promise.reject(errorBack);
    });
  }

  /**
   * @description 批量命令下发，注意：单个命令必须有返回结束标记，否则不能组合成批量命令下发
   * @param {string} command
   * @param {object} {
   *     loadFn = () => {}, // 每条命令返回后的处理函数
   *     ...rest
   *   }
   * @returns
   * @memberof RFBluetooth
   */
  sendBatchCommand(command, {
    loadFn = () => {},
    ...rest
  } = {}) {
    let count = 0;
    const cmds = command.split(/\r\n|\n/);

    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => {
        this.batch = false;
        this.off('batch-process');

        reject(new Error('执行超时'));
      }, 30000);

      this.on('batch-process', (data) => {
        console.log('batch-process', data);

        count++;
        if (count >= 1) {
          loadFn(data);
        }
        if (count >= cmds.length) {
          console.log('批量命令下发结束');
          this.batch = false;
          this.off('batch-process');

          clearTimeout(timer);

          resolve();
        }
      });

      this.sendCommand(
        command,
        {
          desc: '批处理',
          expect: '',
          overtime: cmds.length * 10,
          batch: true
        }
      ).catch((err) => {
        this.batch = false;
        this.off('batch-process');
        reject(err);
      });
    });
  }

  getCommandType(cmd) {
    return CPU2_COMMAND_LIST.findIndex(item => item === cmd) >= 0
      ? 'cpu2'
      : 'cpu1';
  }

  sendTestCommand(command) {
    return this.execute({
      max: 5,
      interval: 20000,
      step: STEPS.SEND_TEST_COMMAND,
      resolveCode: true,
      executeFn: () => {
        const cmd = formatCommandNoEscape(command);
        sendTestCommandByBt(cmd);
      }
    }).then(({ count, data }) => {
      log.postSuccess({
        operate: '发送蓝牙命令---测试',
        send: command,
        receive: data,
        receiveOrigin: data,
        count
      });
      return Promise.resolve(data);
    }).catch((error) => {
      log.postError({
        operate: '发送蓝牙命令---测试',
        error
      });
      return Promise.reject(error);
    });
  }

  /**
   * @description 覆写父类的excute方法
   * @override
   * @param {object} {
   *     max,
   *     interval,
   *     step,
   *     executeFn,
   *     loadFn,
   *     resolveCode = true
   *   }
   * @returns
   * @memberof RFBluetooth
   */
  execute({
    name,
    max,
    session,
    target,
    interval,
    step,
    executeFn,
    loadFn,
    expect,
    overtime,
    logBack
  }) {
    this.currentStep = step;
    if (logBack) {
      this.logExpect = expect;
    }
    const that = this;
    this.outTimer = null;

    // 设置超时，由于命令回调数据可能分多包发送，所以收到每包时都需重设超时
    function setOutTime() {
      if (that.outTimer) {
        clearTimeout(that.outTimer);
        that.outTimer = null;
      }
      that.outTimer = setTimeout(() => {
        that.emmit(`${step}_error`, createError('执行超时', '-1'));
      }, overtime * 1000);
    }

    setOutTime();

    return new Promise((resolve, reject) => {
      function loopExecute() {
        // 成功监听
        that.on(`${step}_success`, (...args) => {
          // 清除超时
          clearTimeout(that.outTimer);
          that.currentStepData = '';
          const { count } = that.timer;
          that.endStep(step);
          resolve({
            count: count(),
            data: args.length > 1 ? args : args[0]
          });
        });

        // 失败监听
        that.on(`${step}_error`, (error) => {
          // 清除超时
          clearTimeout(that.outTimer);
          that.currentStepData = '';
          const { count } = that.timer;
          // eslint-disable-next-line no-param-reassign
          error.count = count();
          that.endStep(step);
          // 上报错误
          reject(error);
        });

        // 监听命令取消
        that.on(`${step}_cancel`, (error) => {
          // 清除超时
          clearTimeout(that.outTimer);
          that.currentStepData = '';
          const { count } = that.timer;
          // eslint-disable-next-line no-param-reassign
          error.count = count();
          that.endStep(step);
          // 上报错误
          reject(error);
        });

        // 蓝牙数据传输是分段传输，所以需要等待结束
        // eslint-disable-next-line consistent-return
        that.on(`${step}_load`, (sessionId, mode, code, data) => {
          setOutTime();

          if (target === 'cpu1') {
            globalStore.setMode(Number(mode));
          }

          if (parseInt(code, 10) !== 0) {
            let codeError = new Error();
            if (code in NATIVE_ERRORS) {
              codeError = new Error(NATIVE_ERRORS[code].description);
            } else {
              codeError = new Error(data);
            }
            codeError.code = code;
            return that.emmit(`${step}_error`, codeError);
          }
          console.log(`${step}接收：${data}`);

          if ((target === 'cpu1' && parseInt(sessionId, 10) !== session) && data.indexOf(HEX_DATA_PREFIX) === -1) {
            console.error(`操作：${name},sessionId不一致,丢弃,原session: ${session},接收session: ${sessionId},数据：${data}`);
            return null;
          }

          // 针对十六进制数据单独做处理
          // eslint-disable-next-line no-use-before-define
          data = resolveParkData(data);

          that.timer.stop();
          if (data.indexOf('err') === 0) {
            const errArr = data.split(',');
            const errCode = errArr[0].split(' ')[1];
            const errMsg = errArr[1].trim();
            // 如果有错不进行重试，交给用户
            that.emmit(`${step}_error`, createError(errMsg, errCode));
          }

          // 每次收到分包数据时执行加载函数
          if (typeof loadFn === 'function') loadFn(data);
          that.currentStepData += data;

          // 判断数据是否接收完成
          if (isEnd(data) && !logBack) {
            // 检查数据是否符合预期
            if (expect && !verifyData(that.currentStepData, expect) && expect !== 'quit shutdown' && expect !== 'cfg.magbase_en') {
              that.emmit(`${step}_error`, createError('返回数据不符合预期', '-2'));
            } else {
              that.emmit(`${step}_success`, that.currentStepData);
            }
          }
        });

        // 重试机制
        that.timer = loopExecuteFn({
          max,
          interval,
          executeFn,
          errorFn: (count, err) => {
            const error = new Error(err || '执行超时');
            error.code = '-1';
            error.count = () => count;
            that.emmit(`${step}_error`, error);
          }
        });
      }

      loopExecute();
    });
  }

  /**
   * @description 结束指定步骤或结束当前步骤
   * @param {string} step 步骤描述
   * @memberof RFBluetooth
   */
  endStep(step) {
    this.off(`${step || this.currentStep}_success`);
    this.off(`${step || this.currentStep}_error`);
    this.off(`${step || this.currentStep}_load`);
    if (this.timer) {
      this.timer.stop();
    }
    if (this.outTimer) {
      clearTimeout(this.outTimer);
      this.outTimer = null;
    }
    this.logExpect = null;
  }

  emmitCallback(...args) {
    // 对java传输过来的字符进行转换
    const argums = args.map(item => decodeURIComponent(item).replace(/\+/g, ' ').replace(/\\t/g, '\t').replace(/\\r\\n/g, '\r\n'));
    const data = argums[3];

    // 过滤掉地磁传输的不符合要求的log日志
    // if (data && /\[log.*\]/.test(data) && data.indexOf('[log]') === -1) {
    //   return;
    // }

    if (data && data.indexOf('[log]') >= 0) {
      cmdLogManager.execute(data);

      if (this.logExpect && data.indexOf(this.logExpect) !== -1) {
        this.emmit.apply(this, [`${this.currentStep}_success`, '0']);
      }

      globalStore.setMode(Number(argums[1]));

      return;
    }

    this.completeData = this.completeData || [];
    this.completeData.push(data);
    if (isEnd(data) && this.batch) {
      this.emmit('batch-process', this.completeData.filter(item => !!item));
      this.completeData = [];
      return;
    }

    if (this.currentStep === 'sendCommand') {
      this.emmit.apply(this, [`${this.currentStep}_load`, ...argums]);
    } else {
      this.emmit.apply(this, [`${this.currentStep}_success`, ...argums]);
    }
  }

  cancel() {
    if (this.currentStep) {
      this.emmit.apply(this, [`${this.currentStep}_cancel`, new Error('主动取消')]);
    }
  }
}

export default new RFBluetooth();


function formatGeoParkData(res) {
  let result = '';
  const start = '<table style="border-collapse:collapse;"><tbody>';
  const end = '</tbody></table>';

  const parkData = {
    序号: {
      range: [0, 2],
      reverse: true,
      format(data) {
        return hexToDecimal(data);
      }
    },
    检测时间: {
      range: [2, 6],
      reverse: true,
      format(data) {
        return formatGeoTime(parseInt(data, 16));
      }
    },
    是否有车: {
      range: [6, 7],
      reverse: true,
      format(data) {
        return hexToDecimal(data);
      }
    },
    有车估值: {
      range: [7, 11],
      reverse: true,
      format(data) {
        return hexToFloat(data);
      }
    },
    方差的值: {
      range: [11, 15],
      reverse: true,
      format(data) {
        return hexToFloat(data);
      }
    },
    雷达的值: {
      range: [15, 16],
      reverse: true,
      format(data) {
        return hexToDecimal(data);
      }
    },
    采集的值: {
      range: [16, 24],
      reverse: false,
      format(data) {
        return splitStringNumber(data, 4)
          .map(item => hexToDecimal(splitStringNumber(item, 2).reverse().join('')))
          .join(',');
      }
    },
    浮动基值: {
      range: [24, 32],
      reverse: false,
      format(data) {
        return splitStringNumber(data, 4)
          .map(item => hexToDecimal(splitStringNumber(item, 2).reverse().join('')))
          .join(',');
      }
    }
  };

  result += start;

  Object.keys(parkData).forEach((key) => {
    const value = parkData[key];
    const hexArr = res.slice(value.range[0], value.range[1]);
    const countValue = value.format(value.reverse ? hexArr.reverse().join('') : hexArr.join(''));
    result += `
      <tr>
        <td style="padding: 2px 5px;text-align: center;border: 1px solid #fff;">${key}</td>
        <td style="padding: 2px 5px;border: 1px solid #fff;">${countValue}</td>
      </tr>
    `;
  });
  return result;
}

function resolveParkData(data) {
  if (data.indexOf(HEX_DATA_PREFIX) !== -1) {
    // eslint-disable-next-line no-param-reassign
    data = data.replace(HEX_DATA_PREFIX, '');
    // eslint-disable-next-line no-param-reassign
    data = splitStringNumber(data, 2);
    return formatGeoParkData(data);
  }
  return data;
}
